module.exports = __webpack_public_path__ + "img/change05.0bbb5ecd.png";